import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import { SignOut } from '@phosphor-icons/react';
import Dashboard from './routes/Dashboard';
import Properties from './routes/Properties';
import Upload from './routes/Upload';
import Review from './routes/Review';
import Templates from './routes/Templates';
import Campaigns from './routes/Campaigns';
import PrintQueue from './routes/PrintQueue';
import Settings from './routes/Settings';
import Login from './routes/Login';
import { api } from './lib/api';
import { cn } from './lib/utils';

const navItems = [
  { to: '/', label: 'Přehled' },
  { to: '/properties', label: 'Nemovitosti' },
  { to: '/campaigns', label: 'Kampaně' },
  { to: '/templates', label: 'Šablony dopisů' },
  { to: '/print-queue', label: 'Tisková fronta' },
  { to: '/settings', label: 'Nastavení' },
];

export default function App() {
  const loc = useLocation();
  const nav = useNavigate();

  // Login má vlastní (full-screen) layout bez headeru.
  if (loc.pathname === '/login') {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
      </Routes>
    );
  }

  async function logout() {
    try {
      await api('/api/auth/logout', { method: 'POST' });
    } catch {
      /* nevadí — pošleme uživatele na /login tak jako tak */
    }
    nav('/login', { replace: true });
  }

  return (
    <div className="min-h-screen flex flex-col">
      <header className="border-b">
        <div className="container flex items-center gap-6 h-14">
          <Link to="/" className="font-semibold tracking-tight">
            Makléř
          </Link>
          <nav className="flex items-center gap-1 text-sm">
            {navItems.map((n) => {
              const active = n.to === '/' ? loc.pathname === '/' : loc.pathname.startsWith(n.to);
              return (
                <Link
                  key={n.to}
                  to={n.to}
                  className={cn(
                    'px-3 py-1.5 rounded-md transition-colors',
                    active
                      ? 'bg-secondary text-secondary-foreground'
                      : 'text-muted-foreground hover:bg-muted hover:text-foreground',
                  )}
                >
                  {n.label}
                </Link>
              );
            })}
          </nav>
          <button
            onClick={logout}
            title="Odhlásit"
            className="ml-auto inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-sm text-muted-foreground hover:bg-muted hover:text-foreground"
          >
            <SignOut size={14} />
            Odhlásit
          </button>
        </div>
      </header>
      <main className="container py-6 flex-1">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/review" element={<Review />} />
          <Route path="/properties/*" element={<Properties />} />
          <Route path="/campaigns/*" element={<Campaigns />} />
          <Route path="/templates/*" element={<Templates />} />
          <Route path="/print-queue" element={<PrintQueue />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
}

function NotFound() {
  return (
    <div className="text-center py-20">
      <h1 className="text-2xl font-semibold">Stránka nenalezena</h1>
      <Link to="/" className="text-sm text-muted-foreground hover:underline mt-2 inline-block">
        Zpět na přehled
      </Link>
    </div>
  );
}
